/* eslint-disable no-console */
// import { ChevronDownIcon, AddIcon } from '@chakra-ui/icons';
import {
  Avatar,
  Box,
  Button,
  ButtonGroup,
  Container,
  Drawer,
  DrawerContent,
  DrawerOverlay,
  Flex,
  HStack,
  IconButton,
  Text,
  useBreakpointValue,
  useColorModeValue,
  useDisclosure,
  useColorMode,
  Menu,
  MenuButton,
  MenuList,
  MenuItem
} from '@chakra-ui/react';
import Link from 'next/link';
import React, { useContext } from 'react';
import { FiMoon, FiSun, FiSettings, FiUsers, FiLogOut } from 'react-icons/fi';
import { useAuthState } from '../contexts/AuthContext';
import { OrganisationStateContext } from '../contexts/OrganisationContext';
import { Logo } from './chakraUIPro/Logo';
import { Sidebar } from './Sidebar';
import { ToggleButton } from './ToggleButton';

export const Navbar = () => {
  const { organisation } = useContext(OrganisationStateContext);
  const { user } = useAuthState();
  const { isOpen, onToggle, onClose } = useDisclosure();
  const { colorMode, toggleColorMode } = useColorMode();
  const isDesktop = useBreakpointValue({ base: false, lg: true });

  return (
    <Box as='nav' bg='bg-surface' boxShadow={useColorModeValue('sm', 'sm-dark')}>
      <Container py={{ base: '3', lg: '4' }} maxWidth='8xl'>
        <Flex justify='space-between'>
          <HStack spacing='4'>
            <Flex>
              <Logo />
              {/* <Text fontWeight='bold' fontSize='2xl' color={useColorModeValue('black', 'white')}>
                eezi
              </Text> */}
            </Flex>
          </HStack>

          {isDesktop ? (
            <HStack spacing='4'>
              <ButtonGroup variant='ghost' spacing='1'>
                <Link href={`/dashboard/${organisation?.id || ''}`}>
                  <Button variant='ghost'>Dashboard</Button>
                </Link>

                <Link href='/sign-out/'>
                  <Button variant='solid' colorScheme='brand' bgColor='brand.500'>
                    Sign out
                  </Button>
                </Link>

                <IconButton
                  icon={colorMode === 'light' ? <FiMoon fontSize='1.25rem' /> : <FiSun fontSize='1.25rem' />}
                  onClick={toggleColorMode}
                  aria-label='Toggle color mode'
                />
                <Menu>
                  <MenuButton>
                    <IconButton icon={<FiSettings fontSize='1.25rem' />} aria-label='Settings' />
                  </MenuButton>
                  <MenuList>
                    <Link href={`/users/${organisation?.id || ''}`}>
                      <MenuItem>
                        <FiUsers />
                        <Text ml={2}>Users</Text>
                      </MenuItem>
                    </Link>
                  </MenuList>
                </Menu>
              </ButtonGroup>
              <Menu>
                <MenuButton>
                  <Avatar
                    boxSize='10'
                    name={`${user?.fName} ${user?.lName}`}
                    bgColor='brand.500'
                    color={colorMode === 'light' ? ' white' : 'blackAlpha.800'}
                  />
                </MenuButton>
                <MenuList>
                  <Link href='/sign-out/'>
                    <MenuItem>
                      <FiLogOut />
                      <Text ml={2}>Sign out</Text>
                    </MenuItem>
                  </Link>
                </MenuList>
              </Menu>
              {/* <Avatar
                boxSize='10'
                name={`${user?.fName} ${user?.lName}`}
                bg='brand'
                color={colorMode === 'light' ? ' white' : 'blackAlpha.800'}
              /> */}
            </HStack>
          ) : (
            <>
              <ToggleButton isOpen={isOpen} aria-label='Open Menu' onClick={onToggle} />
              <Drawer
                isOpen={isOpen}
                placement='left'
                onClose={onClose}
                isFullHeight
                preserveScrollBarGap
                trapFocus={false}
              >
                <DrawerOverlay />
                <DrawerContent>
                  <Sidebar organisation={organisation} />
                </DrawerContent>
              </Drawer>
            </>
          )}
        </Flex>
      </Container>
    </Box>
  );
};
